import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import FooterTabBarLayout from '../../layouts/FooterTabBarLayout';
import HeaderBar from '../../layouts/HeaderBar';
import ChatListContainer from '../../containers/ChatListContainer';
import { IoChatboxOutline } from 'react-icons/io5';
import NotificationIcon from '../../layouts/NotificationIcon';
import { getChatroomList } from '../../../api/ChatApi';

const ChatListPage = () => {
  const navigate = useNavigate();
  const [chatRooms, setChatRooms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchChatRooms();
  }, []);

  const fetchChatRooms = async () => {
    try {
      setLoading(true);
      const response = await getChatroomList();

      // API 응답 데이터를 컴포넌트에서 사용할 형태로 변환
      const formattedChatRooms = (response.chatroomListDtoList || []).map(room => ({
        id: room.meetingId,
        meetingTitle: room.meetingTitle,
        meetingImageUrl: room.meetingImageUrl,
        lastChatContent: room.lastChatContent,
        lastChatCreatedAt: room.lastChatCreatedAt,
        hasUnreadChat: room.hasUnreadChat || false
      }));

      setChatRooms(formattedChatRooms);
    } catch (error) {
      console.error('채팅방 리스트 조회 실패:', error);
      setChatRooms([]);
    } finally {
      setLoading(false);
    }
  };

  const handleChatClick = (meetingId) => {
    navigate(`/app/chat/${meetingId}`);
  };

  // 헤더 오른쪽 아이콘 설정
  const rightIcons = [
    {
      icon: <NotificationIcon />,
      onClick: () => {},
      title: '알림'
    }
  ];

  if (loading) {
    return (
      <FooterTabBarLayout>
        <HeaderBar
          title="채팅"
          rightIcons={rightIcons}
        />
        <div className="flex justify-center items-center py-16">
          <div className="text-gray-500">로딩 중...</div>
        </div>
      </FooterTabBarLayout>
    );
  }

  return (
    <FooterTabBarLayout>
      <HeaderBar
        title="채팅"
        rightIcons={rightIcons}
      />

      <div className="p-4 max-w-lg mx-auto">
        {chatRooms.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-16">
            <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mb-6">
              <IoChatboxOutline size={40} className="text-amber-500" />
            </div>
            <p className="text-gray-600 text-lg font-medium mb-2">참여중인 채팅방이 없습니다</p>
            <p className="text-gray-500 text-sm text-center">
              모임에 참여하면 채팅방이 생성됩니다
            </p>
          </div>
        ) : (
          <div className="space-y-4">
            {chatRooms.map(chat => (
              <ChatListContainer
                key={chat.id}
                meetingTitle={chat.meetingTitle}
                meetingImageUrl={chat.meetingImageUrl}
                lastChatContent={chat.lastChatContent}
                lastChatCreatedAt={chat.lastChatCreatedAt}
                hasUnreadChat={chat.hasUnreadChat}
                onClick={() => handleChatClick(chat.id)}
              />
            ))}
          </div>
        )}
      </div>
    </FooterTabBarLayout>
  );
};

export default ChatListPage;
